/* eslint-disable react/require-default-props */
import React from "react"

import LogoSvg from "../../../images/svg/logo.svg"
import LogoIconSvg from "../../../images/svg/logoIcon.svg"

const Logo = ({
  spinning = false,
  full = false,
  newWindow = true,
  width = 120,
  ...props

}) => {

  const maxWidth = width ? width : '180px'

  return (
    <>
      {full
        ? <a href="/" className="logo full" target={newWindow ? '_blank' : '_self' } style={{
            maxWidth: maxWidth,
            display: full ? 'inline-block' : 'none' }}>
            <LogoSvg className="logo-svg" width={width} />
          </a>
        : <a href="/" className="logo mobile" style={{ maxWidth: maxWidth }}  >
            <LogoIconSvg className="logo-svg" />
          </a>
      }
    </>
  )
}

export default Logo